module.exports = __webpack_public_path__ + "img/6.fa15ea25.jpg";